import { memo, useCallback } from 'react'
import { MyTaskListDataGrid } from './components/myTaskListDataGrid/myTaskListDataGrid'
import { useAppSelector } from 'states/hooks'
import { MyTaskDisplayModeButtonGroup } from 'enums/app'
import { MyTaskListCalendar } from './components/myTaskListCalendar/mylTaskListCalendar'
import { MyTaskListGantt } from './components/myTaskListGantt/myTaskListGantt'

export const MyTaskListPanel = memo(() => {
  // 選択中のタスクリスト表示モードを取得
  const selectedTaskListDisplayMode = useAppSelector(
    (state) => state.home.selectedMyTaskListDisplayMode
  )

  // タスクリストの表示モードによって表示を切り替える
  const renderTaskList = useCallback(() => {
    switch (selectedTaskListDisplayMode) {
      case MyTaskDisplayModeButtonGroup.List.id:
        return (
          <div className="flex h-full overflow-y-hidden">
            <MyTaskListDataGrid />
          </div>
        )
      case MyTaskDisplayModeButtonGroup.Calendar.id:
        return <MyTaskListCalendar />
      case MyTaskDisplayModeButtonGroup.Gantt.id:
        return (
          <div className="flex-1 overflow-y-hidden">
            <MyTaskListGantt />
          </div>
        )
      default:
        return null
    }
  }, [selectedTaskListDisplayMode])

  return renderTaskList()
})
